//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "auditing-sup-score",
  data(){
    return{
      scoreData:{},
      sourceId:null,
      schemeDetailId:null
    }
  },
  methods:{
    getScoreData(){
      this.$loadingShow();
      this.$get(`api/sourceRating/audit-scoring/${this.sourceId}/${this.schemeDetailId}`).then((res) => {
        this.scoreData = res;
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      });
    },
    viewOffer(){
      if (!this.scoreData.scoringSchemeDetail.enableViewSupAttachs) {
        this.$router.push(`/parity-offer/${this.scoreData.sourcing.sourceRoId}?hiddenAttach=true`);
      } else if (!this.scoreData.scoringSchemeDetail.enableViewPrice) {
        this.$router.push(`/parity-offer/${this.scoreData.sourcing.sourceRoId}?hiddenPrice=true&showAttach=${this.scoreData.scoringSchemeDetail.enableViewSupAttachs}`);
      } else {
        this.$router.push(`/parity-offer/${this.scoreData.sourcing.sourceRoId}?showAttach=${this.scoreData.scoringSchemeDetail.enableViewSupAttachs}`);
      }
    },
    changeScoreShow(sup){
      if(sup.scoreShow){
        this.$set(sup,'scoreShow',false);
        return;
      }
      this.$set(sup,'scoreShow',true);
    },
    viewScore(supScore){
      if(this.scoreData.scoringSchemeDetail.auditStatus === 'approval'){
        this.$router.push(`/auditing-score/detail/${this.scoreData.scoringSchemeDetail.id}/${supScore.scoringObjectId}?audited=1`);
        return;
      }
      this.$router.push(`/auditing-score/detail/${this.scoreData.scoringSchemeDetail.id}/${supScore.scoringObjectId}`);
    },
    approval(){
      let str;
      if(this.scoreData.scoringSchemeDetail.status !== 'FINISH'){
        str = '当前还有人员未完成评分且审核通过后评分不能修改，请确认是否要提交审核';
      }else{
        str = '审核通过后评分不能修改，请确认是否提交审核通过？';
      }
      this.$vux.confirm.show({
        title:str,
        onConfirm:() => {
          this.$loadingShow();
          this.$post(`api/scoring-value/leader-approval/${this.schemeDetailId}`).then((res) => {
            this.$vux.toast.text('提交成功');
            this.$loadingHide();
            this.$router.go(-1);
          }).catch(() => {
            this.$loadingHide();
          })
        }
      })
    }
  },
  mounted(){
    this.sourceId = this.$route.params.sourceId;
    this.schemeDetailId = this.$route.params.detailId;
    this.getScoreData();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-score/auditing-sup-score.vue